module.exports = __webpack_public_path__ + "img/CG1_42.78e97ba.png";